import { Helper } from '../Helper';
export class ExpHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'TUCK');
                sb.emitPushInt(node, 0);
                sb.emitOp(node, 'NUMEQUAL');
            },
            whenTrue: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                sb.emitPushInt(node, 1);
            },
            whenFalse: () => {
                sb.emitHelper(node, options, sb.helpers.if({
                    condition: () => {
                        sb.emitOp(node, 'OVER');
                        sb.emitPushInt(node, 0);
                        sb.emitOp(node, 'LT');
                    },
                    whenTrue: () => {
                        sb.emitPushInt(node, 1);
                        sb.emitOp(node, 'SWAP');
                        sb.emitOp(node, 'DIV');
                        sb.emitOp(node, 'SWAP');
                        sb.emitOp(node, 'NEGATE');
                        sb.emitOp(node, 'SWAP');
                    },
                }));
                const y = sb.scope.addUnique();
                const n = sb.scope.addUnique();
                const x = sb.scope.addUnique();
                sb.scope.set(sb, node, options, x);
                sb.scope.set(sb, node, options, n);
                sb.emitPushInt(node, 1);
                sb.scope.set(sb, node, options, y);
                sb.emitHelper(node, options, sb.helpers.forLoop({
                    condition: () => {
                        sb.scope.get(sb, node, options, n);
                        sb.emitPushInt(node, 1);
                        sb.emitOp(node, 'GT');
                    },
                    each: () => {
                        sb.emitHelper(node, options, sb.helpers.if({
                            condition: () => {
                                sb.scope.get(sb, node, options, n);
                                sb.emitOp(node, 'DUP');
                                sb.emitPushInt(node, 2);
                                sb.emitOp(node, 'MOD');
                                sb.emitPushInt(node, 0);
                                sb.emitOp(node, 'NUMEQUAL');
                            },
                            whenTrue: () => {
                                sb.emitPushInt(node, 2);
                                sb.emitOp(node, 'DIV');
                                sb.scope.set(sb, node, options, n);
                                sb.scope.get(sb, node, options, x);
                                sb.emitOp(node, 'DUP');
                                sb.emitOp(node, 'MUL');
                                sb.scope.set(sb, node, options, x);
                            },
                            whenFalse: () => {
                                sb.emitOp(node, 'DEC');
                                sb.emitPushInt(node, 2);
                                sb.emitOp(node, 'DIV');
                                sb.scope.set(sb, node, options, n);
                                sb.scope.get(sb, node, options, x);
                                sb.emitOp(node, 'DUP');
                                sb.scope.get(sb, node, options, y);
                                sb.emitOp(node, 'MUL');
                                sb.scope.set(sb, node, options, y);
                                sb.emitOp(node, 'DUP');
                                sb.emitOp(node, 'MUL');
                                sb.scope.set(sb, node, options, x);
                            },
                        }));
                    },
                    cleanup: () => {
                    },
                }));
                sb.scope.get(sb, node, options, x);
                sb.scope.get(sb, node, options, y);
                sb.emitOp(node, 'MUL');
            },
        }));
    }
}

//# sourceMappingURL=ExpHelper.js.map
